import AppDelivery from './component'

export default AppDelivery
